import { ComponentProps } from 'react'

import {
  FieldWrapper,
  FieldWrapperProps
} from '@/components/form/field-wrapper'

import { isFieldInvalid } from '@/utils'

import { Checkbox as BaseCheckbox } from '../ui/checkbox'
import { useFieldContext } from './form'

export type CheckboxProps = {
  label?: string
} & Omit<BaseCheckboxProps, 'ref'> &
  Pick<FieldWrapperProps, 'classNames'>

type BaseCheckboxProps = ComponentProps<typeof BaseCheckbox>

export const Checkbox: React.FC<CheckboxProps> = ({
  classNames,
  label,
  ...props
}) => {
  const field = useFieldContext<boolean>()
  const isInvalid = isFieldInvalid(field)

  return (
    <FieldWrapper
      classNames={classNames}
      field={field}
      label={label}
      required={props.required}
    >
      <BaseCheckbox
        checked={field.state.value}
        data-invalid={isInvalid || undefined}
        name={field.name}
        onCheckedChange={(checked) => {
          field.handleChange(() => checked === true)
        }}
        {...props}
      />
    </FieldWrapper>
  )
}
